// Props for Load Roles Handlers Hook
export interface U3148LoadRolesHandlersParams<T = any> {
  doLoadRolesFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for Load Roles Handlers Hook
export interface U3148LoadRolesHandlersReturn {
  loadRoles: () => void;
}

// Handlers for loading roles
export function useU3148LoadRolesHandlers<T extends { id: string } = any>({ doLoadRolesFn, onSuccess, onError }: U3148LoadRolesHandlersParams<T>): U3148LoadRolesHandlersReturn {
  const loadRoles = async () => {
    try {
      const response = await doLoadRolesFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadRoles };
}
